// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3--dU","modalFooterButton":"ModalNotes_modalFooterButton__2mjjk"};